<template>
  <div>
    <Header />
    <Logo :msg="$t('button.Associated_Email')" />
    <Loading v-if="isLoading" />
    <div class="conter">
      <div class="root">
        <el-form
          :model="Register"
          ref="RegisterForm"
          label-width="0"
          class="RegisterForm"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="Register.phone"
              :placeholder="$t('placeholder.Please_enter_register_account')"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="Register.pass"
              :placeholder="$t('placeholder.Please_enter_your_email_address')"
            ></el-input>
          </el-form-item>

          <el-form-item :prop="$t('prop.Verification_code')" class="code">
            <el-input
              v-model="Register.sendcode"
              :placeholder="$t('placeholder.shortmessage-044')"
            ></el-input>
            <el-button
              type="button"
              @click="sendcode"
              :disabled="disabled"
              v-if="disabled == false"
              >{{$t('button.Send_verification_code')}}
            </el-button>
            <el-button
              type="button"
              @click="sendcode"
              :disabled="disabled"
              v-if="disabled == true"
              >{{ btntxt }}
            </el-button>
          </el-form-item>

          <el-form-item>
            <el-button type="success" @click="submitForm">{{$t('button.submit')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <Foot />
    <el-button :plain="true" v-show="false"></el-button>
  </div>
</template>
<script>
import { post, get } from '@/utils/request';

import Header from '@/components/header.vue';
import Baoyou from '@/components/order/baoyou1.vue';
import Foot from '@/components/foot.vue';
import Logo from '@/components/order/safe/logo.vue';
export default {
  components: {
    Header,
    Baoyou,
    Foot,
    Logo,
  },
  data() {
    return {
      Register: {
        phone: '',
        sendcode: '',
        pass: '',
        checkPass: '',
      },
      disabled: false,
      time: 0,
      btntxt: this.$t('common.resend'),

      input3: '',
      select: '',
      myForm: {},
      isLoading: false,
    };
  },
  created() {
    this.getorder();
  },
  methods: {
    getorder() {
      get('api/member/selMemberInfo').then((res) => {
        this.Register.pass = res.data.data.email;
        this.Register.phone=res.data.data.userName;
      });
    },
    //发送验证码
    sendcode() {
      this.isLoading = true;
      const regPhone = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      const regEmail=/^([a-z0-9A-Z]+[-|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/;
      if (this.Register.phone == ''||this.Register.phone == null) {
        this.isLoading = false;
        this.$message.warning({
          message: this.$t('message.Please_enter_register_account'),

        });
        return;
      }
      if (!regPhone.test(this.Register.phone)&&!regEmail.test(this.Register.phone)) {
        this.isLoading = false;
        this.$message.warning({
           message: this.$t('message.Incorrect_register_account_format'),

        });
        return;
      } else {
        get('api/account/msginformation?phone=' + this.Register.phone).then(
          (res) => {
            this.isLoading = false;
            if (res.data.msg == '0') {
              this.$message.success({
                message: this.$t('message.Sent_successfully'),
              });
              this.time = 60;
              this.disabled = true;
              this.timer();
            } else {
              this.$message.warning({
                message: this.$t('message.Send_failure'),
              });
            }
          }
        );
      }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + this.$t('common.Reacquire_after');
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = this.$t('button.Get_verification_code');
        this.disabled = false;
      }
    },
    submitForm() {
      this.isLoading = true;
      if (this.Register.pass == ''||this.Register.pass==null) {
        this.isLoading = false;
        this.$message.warning({
          message: this.$t('message.Email_cannot_be_empty'),

        });
        return;
      }
      const regEmail = /^([a-z0-9A-Z]+[-|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/;
      if (!regEmail.test(this.Register.pass)) {
        this.$message.warning({
          message: this.$t('message.Please_enter_the_correct_email_format'),
        });
        this.isLoading = false;
        return;
      } else if (
        this.Register.phone &&
        this.Register.sendcode &&
        this.Register.pass
      ) {
        post('api/account/updateemail', {
          phone: this.Register.phone,
          code: this.Register.sendcode,
          email: this.Register.pass,
        }).then((res) => {
          this.isLoading = false;
          if (res.data.msg == this.$t('message.Successful_operation')) {
            this.$message.success({
              message: this.$t('message.Modified_successfully'),
            });
            this.$router.push({
              name: 'Safe',
            });
          }else if(res.data.msg == '0'){
            this.$message.warning({
              message: this.$t('message.Verification_code_error'),
            });
          }else if(res.data.msg == '1'){
            this.$message.warning({
              message: this.$t('message.Invalid_captcha'),
            });
          }else if(res.data.msg == '2'){
            this.$message.warning({
              message: this.$t('message.Account_not'),
            });
          }else if(res.data.msg == '3'){
            this.$message.warning({
              message: this.$t('message.Account_error'),
            });
          } else {
            this.$message.error({
              message: this.$t('message.Modification_failure'),
            });
          }
        });
      } else {
        this.isLoading = false;
        this.$message.warning({
          message: this.$t('message.Please_complete'),
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.conter {
  width: 100%;
  margin-top: 149px;
  .root {
    background: url('http://img.hena360.cn/login_bj.jpg') no-repeat center;
    background-size: 100% 100%;
    height: 10px;
    width: 440px;
    margin: auto;

    form {
      width: 90%;
      margin: auto;
      .code {
        .el-input {
          width: 65%;
          border-radius: 0px;
          float: left;
          display: inline-block;
        }
        .el-button {
          width: 35%;
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          border-left: 0px;
          float: left;
          display: inline-block;
        }
      }
      .el-button--success {
        width: 100%;
        background-color: #245af2;
        border: none;
        color: #fff;
      }
    }
  }
}

.form-wrapper {
  margin-top: 50px;
  width: 500px;
  margin-left: 0;
}
.conter {
  padding-bottom: 333px;
  width: 100%;
  .buzhou {
    width: 612px;
    margin: auto;
    margin-top: 50px;
    .logo-search-progress {
      width: 100%;
      height: 104px;
    }
  }
  .input {
    width: 612px;
    height: 100%;
    margin: auto;
    margin-top: 90px;
    display: flex;
    .el-select {
      width: 250px;
    }
  }
  .yanzheng {
    width: 612px;
    margin: auto;
    text-align: center;
    cursor: pointer;
  }
}
</style>
